module.exports = __webpack_public_path__ + "img/number-thumb-30.0434ec66.jpg";